import React from 'react'
import { Card, Space } from 'antd'
import UsersTable from './UsersTable'
import UserSearchInput from './UserSearchInput'
import { useSelector } from 'react-redux'
import { isNumber } from 'lodash'
import EditUserDrawer from '../edit/EditUserDrawer'
import InviteUserButton from '../invite/InviteUserButton'
import userSelectors from '../../../../../store/selectors/user.selectors'

const UsersCard = () => {
    const editingUserId = useSelector(userSelectors.editingUserId)

    const extra = (
        <Space>
            <UserSearchInput />
            <InviteUserButton />
        </Space>
    )
    
    return (
        <Card title='Users' bordered={false} extra={extra}>
            <UsersTable />
            {isNumber(editingUserId) && <EditUserDrawer />}
        </Card>
    )
}

export default UsersCard
